import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ILicenca, LicencasService } from 'src/app/shared/api/licencas/licencas.service';
import { MetadadosService } from 'src/app/shared/api/metadados';
import { IMaterial } from 'src/app/shared/api/testes/adm-materiais.service';
import { MidiasService } from 'src/app/shared/api/testes/midias.service';
import { PessoalMateriaisService } from 'src/app/shared/api/testes/pessoal-materiais.service';
import { TestesService } from 'src/app/shared/api/testes/testes-cliente.service';
import { ITeste } from 'src/app/shared/api/testes/testes.service';
import { ConstantsWidthHeightMidia } from 'src/app/shared/components/card-midia/card-midia-constants';
import { ActionToolbar } from 'src/app/shared/components/toolbar/toolbar.component';
import { clonarObjeto } from 'src/app/shared/functions/objects-functions';
import { AuthService } from 'src/app/shared/services/auth.service';

interface ILicencaMateriais {
    licenca: ILicenca;
    materiais: IMaterial[];
}

export interface IGrupoLicenca {
    idGrupo: string;
    licencasMateriais: ILicencaMateriais[],
    checkoutUrl?: string
}

@Component({
    selector: 'app-grupo-testes',
    templateUrl: './grupo-testes.component.html',
    styleUrls: ['./grupo-testes.component.scss']
})
export class GrupoTestesComponent implements OnInit, AfterViewInit {
    @ViewChildren('grupoContainer') grupoContainers!: QueryList<ElementRef>;

    readonly GAP_ENTRE_CARDS = 20;

    loading = false;
    grupos: IGrupoLicenca[] = [];
    actionsToolbar: ActionToolbar[] = [];
    titulo = '';
    teste: ITeste | null = null;
    metadadosGreen: any = null;

    podeScrollarEsquerda: boolean[] = [];
    podeScrollarDireita: boolean[] = [];

    idTestePrincipal!: string;
    constantsWidthHeightMidia = ConstantsWidthHeightMidia;
    urlCapaMaterial: string | null = null;

    constructor(
        public licencasService: LicencasService,
        private router: Router,
        private route: ActivatedRoute,
        private materiaisService: PessoalMateriaisService,
        private authService: AuthService,
        private testesService: TestesService,
        private midiasService: MidiasService,
        private metadadosService: MetadadosService
    ) { }

    ngOnInit(): void {
        this.authService.setTheme('dark');

        this.idTestePrincipal = this.route.snapshot.paramMap.get('id')!;

        this.obterDetalhesTeste();
    }

    ngAfterViewInit(): void {
        this.grupoContainers.changes.subscribe(() => {
            this.calcularPosicoesScroll();
        });

        this.calcularPosicoesScroll();
    }

    @HostListener('window:resize')
    onResize(): void {
        this.calcularPosicoesScroll();
    }

    private listarLicencas(params: any = { pagina: 1, tamanho: 999 }) {
        this.loading = true;
        params['teste'] = this.idTestePrincipal;

        this.licencasService.get(params).subscribe({
            next: (response) => {
                this.loading = false;
                const licencas = this.ordenarLicencas(response.resultados);
                this.obterNomeTestePrincipal(licencas);
                this.listarMateriaislicencas(licencas);
            }
        });
    }

    private ordenarLicencas(licencas: ILicenca[]) {
        return licencas.sort((a, b) => {
            return new Date(b.data_criacao).getTime() - new Date(a.data_criacao).getTime()
        });
    }

    private obterNomeTestePrincipal(licencas: ILicenca[]) {
        const licenca = licencas.find((licenca) => licenca.teste.uuid == this.idTestePrincipal);
        this.titulo = licenca?.teste.nome || '';
    }

    private separarLicencasEmGrupos(licencas: ILicenca[], materiais: IMaterial[]) {
        this.grupos = [];

        licencas.forEach((licenca) => {
            let grupo: IGrupoLicenca | undefined = this.grupos.find((grupo) => grupo.idGrupo == licenca.grupo);

            if (!grupo) {
                grupo = {
                    idGrupo: licenca.grupo,
                    licencasMateriais: []
                };

                this.grupos.push(grupo);
            }

            let materiaisTeste = materiais.filter(
                (material) => material.teste == licenca.teste.uuid
            );

            grupo.licencasMateriais.push({ licenca: licenca, materiais: materiaisTeste });
        });

        this.ordenarLicencasPorIdAnterior();
        this.adicionarCheckoutGreen();
    }

    /**
     * Nos grupos de licenças que não possuem o sucessor 
     * adicionar o checkout da green para o cliente comprar
     */
    private adicionarCheckoutGreen() {
        const checkoutUrl = this.teste?.green_checkout_url;
        if (checkoutUrl == null) return;

        this.grupos.forEach(grupo => {
            if (grupo.licencasMateriais.length == 1) {
                grupo.checkoutUrl = this.teste?.green_checkout_url;
            }
        })
    }

    private ordenarLicencasPorIdAnterior() {
        this.grupos.forEach(grupo => {
            const licencasMateriaisOrdenadas: ILicencaMateriais[] = [];

            const primeiraLicenca = grupo.licencasMateriais.find(licencaMateriais => licencaMateriais.licenca.teste_antecessor == null);

            let atual = primeiraLicenca;

            if (!atual) {
                // por algum motivo não tem nenhuma licença com teste_antecessor null
                // por exemplo, foi dado a ele acesso a segunda licença e não a primeira
                // encontrar a licença principal
                atual = this.encontrarPrimeiraLicencaEmCasoDeTodasPossuiremAntecessor(grupo.licencasMateriais);
            }

            while (atual) {
                licencasMateriaisOrdenadas.push(clonarObjeto(atual));
                atual = grupo.licencasMateriais.find(licencaMat => licencaMat.licenca.teste_antecessor?.uuid == atual!.licenca.teste.uuid);
            }

            grupo.licencasMateriais = licencasMateriaisOrdenadas;
        })
    }

    private encontrarPrimeiraLicencaEmCasoDeTodasPossuiremAntecessor(licencasMateriais: ILicencaMateriais[]) {
        const antecessores = new Set(licencasMateriais.map(l => l.licenca.teste_antecessor!.uuid));
        return licencasMateriais.find(l => !antecessores.has(l.licenca.teste.uuid));
    }

    private listarMateriaislicencas(licencas: ILicenca[]) {
        this.materiaisService.get({ teste: this.idTestePrincipal }).subscribe({
            next: (response) => {
                this.separarLicencasEmGrupos(licencas, response.resultados);
            }
        });
    }

    private obterDetalhesTeste() {
        const sub = this.testesService.detail(this.idTestePrincipal).subscribe({
            next: (teste) => {
                sub.unsubscribe();
                this.teste = teste;
                this.obterCapaMateriais(teste);
                this.listarLicencas();
                this.obterMetadadosGreen();
            }
        })
    }

    private obterMetadadosGreen() {
        if (!this.teste?.green_checkout_id) return;

        const sub = this.metadadosService.obterMetadadosGreen(this.teste?.green_checkout_id).subscribe({
            next: (response) => {
                sub.unsubscribe();
                this.metadadosGreen = response;
            }
        })
    }

    /**
     * Para obter a capa dos materiais, preciso obter os detalhes do teste.
     * Nos detalhes do teste virá o id da trilha.
     * Usarei o id da trilha para obter as midias da trilha. 
     * A mídia das trilhas de posição 1 (segunda) conterá  a capa dos materiais
     */
    private obterCapaMateriais(teste: ITeste) {
        const idTrilha = teste.trilha!;

        const subMidia = this.midiasService.getMidiaCapaTrilha(idTrilha).subscribe({
            next: (responseMidia) => {
                subMidia.unsubscribe();
                this.urlCapaMaterial = responseMidia.resultados[1].url!;
            }
        })
    }

    onScroll(event: Event, index: number) {
        this.atualizarFlagsScroll(index, event.target as HTMLElement);
    }

    scrollLeft(index: number) {
        const container = this.grupoContainers.toArray()[index]?.nativeElement;
        if (container) {
            container.scrollBy({
                left: -this.quantidadeScroll(container),
                behavior: 'smooth'
            });
        }
    }

    scrollRight(index: number) {
        const container = this.grupoContainers.toArray()[index]?.nativeElement;
        if (container) {
            container.scrollBy({
                left: this.quantidadeScroll(container),
                behavior: 'smooth'
            });
        }
    }

    /**
     * Desloca uma quantidade equivalente à largura de um card (incluindo o gap),
     * simulando a movimentação por "página" estilo Netflix.
     */
    private quantidadeScroll(container: HTMLElement): number {
        const primeiroCard = container.querySelector<HTMLElement>('.card-item');
        const larguraCard = primeiroCard?.offsetWidth ?? 300;
        return larguraCard + this.GAP_ENTRE_CARDS;
    }

    private calcularPosicoesScroll() {
        this.grupoContainers.toArray().forEach(({ nativeElement }, index) => {
            this.atualizarFlagsScroll(index, nativeElement);
        });
    }

    private atualizarFlagsScroll(index: number, container: HTMLElement) {
        const maxScroll = container.scrollWidth - container.clientWidth;

        this.podeScrollarEsquerda[index] = container.scrollLeft > 1;
        this.podeScrollarDireita[index] = container.scrollLeft < maxScroll - 1;
    }
}
